---
seo:
  title: Doctors
  description: setup your doctors
---

# **Doctors**

Setup a doctor here

- **Doctor Name**
- **[Staff Member](/staff/settings/company-settings/users/permissions)**
  - the user must have **Doctor Auth** permissions to be visible on this list

---

- **Send Doctor WhatsApp for patient waiting**
  - the user must have a WhatsApp number assigned in their **[Staff Member](/staff/settings/company-settings/users)** profile
  - when this setting is turned on it will display a **Call Doctor** button on the patient's timeline
    - when the button is pushed it will trigger a WhatsApp to the doctor containing
      - _Team member's name_
      - _Patient name_
      - _Treatment Code_
      - _Number of months_
      - _Wires_
      - _Surgery decision_

![whatsapp_call](./assets/whatsapp_call.png)

![whatsapp_call_message](./assets/whatsapp_call_message.png)

_**Note:** these messages are great in combination with a smart watch so that doctor can arrive at the patient with the information they need_

---
